import React from 'react';

export default function (props) {
   
    return (
       <div className={props.className}>
            {
                props.label ? <div className="mb-2">{props.label}</div> : null
            }
           
            
            <div className="form-row">
                <div className="form-group input-group-sm col-md-12">
                    <input
                        type={props.type}
                        onChange={props.onChange}
                        placeholder={props.placeholder}
                        className="form-control"
                        value={props.value}
                    />
                </div>
            </div>
            
       </div>
    )
}
